module.exports = __webpack_public_path__ + "static/media/meditation2.d60b7a46.mp3";